import { SettingsType, useSettingsHook } from '../hooks/settingsStorageHook';
import { Cornerstone } from '@rpi/api';
import React from 'react';

type BlurbContext = {
  settings: SettingsType | null;
  currencyFormatter: (value?: Cornerstone.MonetaryAmount) => string;
};

export const BlurbContextType = React.createContext<BlurbContext | null>(null);

export const useBlurbContext = () => {
  const blurbContext = React.useContext(BlurbContextType);

  if (!blurbContext) {
    throw new Error(
      'useBlurbContext has to be used within <BlurbContext.Provider>',
    );
  }

  return blurbContext;
};

// me needs loading state and error state
export const BlurbProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { settings, currencyFormatter } = useSettingsHook();

  return (
    <BlurbContextType.Provider
      value={{
        settings,
        currencyFormatter,
      }}
    >
      {children}
    </BlurbContextType.Provider>
  );
};
